/**
 * Created by XXX
 * Description:
 *
 * ------ maintenance history ------
 * 07/02/2019 Bowen Li: make the collapse/expand button move
 */

import { Component, OnInit, ContentChild, TemplateRef, HostListener, Input, ElementRef, Renderer2, HostBinding, OnDestroy } from '@angular/core';
import { snippetView, sidelistView, toplistView, LayoutViewType, ResearchLayoutConfig, ResearchLayoutActions, ResearchLayoutEvents } from './research-layout.data';
import { trigger, transition, style, animate } from '@angular/animations';
import { Subscription } from 'rxjs';

@Component({
    // tslint:disable-next-line: component-selector
    selector: 'research-layout',
    templateUrl: './research-layout.component.html',
    styleUrls: ['./research-layout.component.scss'],
    animations: [trigger('draggingMenu', [transition('1 => 0', [style({
        top: '{{top}}', left: '{{left}}', right: '{{right}}', bottom: '{{bottom}}'
    }
    ), animate('100ms cubic-bezier(0.680, -0.550, 0.265, 1.550)', style('*'))])]), trigger('menuState', [transition(':enter', [style({
        transform: 'scale(0)'
    }
    ), animate('0ms cubic-bezier(0.680, -0.550, 0.265, 1.550)', style({
        transform: 'scale(1)'
    }
    )),
    ]), transition(':leave', [animate('0ms cubic-bezier(0.680, -0.550, 0.265, 1.550)', style({
        transform: 'scale(0)'
    }
    ))])])],
})

export class ResearchLayoutComponent implements OnInit, OnDestroy {
    @ContentChild('refinedBy', { static: false }) refinedBy: TemplateRef<any>;
    @ContentChild('snippet', { static: false }) snippet: TemplateRef<any>;
    @ContentChild('preview', { static: false }) preview: TemplateRef<any>;
    @ContentChild('sideList', { static: false }) sideList: TemplateRef<any>;
    @ContentChild('topList', { static: false }) topList: TemplateRef<any>;
    @Input() config: ResearchLayoutConfig;
    /*  below is the variables for layout */
    view = 1;
    refineByShow = true;
    snippetView: LayoutViewType;
    sidelistView: LayoutViewType;
    toplistView: any;
    /* check the splitter bar whether is draged
       if draged, when collapsed, the refined width give the preview panel. when expand, the refined width get from the preview panel.
       if not, set the default value.
     */
    isdraged = false;
    disableCollapse = false;
    /*  above is the variables for layout */

    // for draggingButton animation
    top: string;
    left: string;
    bottom: string;
    right: string;

    private _preWindowWidth = 0; // to adjust the window width before resizing
    private _collapseButton = 28;
    private _expandButton = 28;
    private _navigationWidth = 64;
    private _panelTopMargin = 119;
    private _clickTime: number;
    private _cancelClick = false;
    private _el: HTMLElement;
    private _destroySubscriptions: Array<Subscription> = [];

    // for draggingButton animation
    private _left: number;
    private _top: number;

    // Binding host element to @menuState animation
    @HostBinding('@menuState') public menuState = false;

    constructor(
        private _element: ElementRef,
        private _renderer2: Renderer2,
    ) {
        this._el = this._element.nativeElement;
    }

    @HostListener('window:resize', ['$event'])
    onResize(e) {
        if (e.target.innerWidth !== this._preWindowWidth) {
            this.initCollapse(e.target.innerWidth);
        }
        this._preWindowWidth = e.target.innerWidth;
    }

    ngOnInit() {
        this._preWindowWidth = window.innerWidth;
        this.view = this.config.layoutMode;

        // for being reused without refinedBy
        this.disableCollapse = this.config.disableCollapse;

        this.initCollapse(window.innerWidth);

        // If creating screen, the parameter named isCollapsed will be deleted.
        if (this.config.isCollapsed) {
            this.refineByShow = !this.config.isCollapsed;
        }
        this.initLayout();

        this._destroySubscriptions.push(
            this.config.actions$.subscribe(action => this._actionHandler(action)),
        );
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(subscription => subscription.unsubscribe());
    }

    collapse() {
        if (!this._cancelClick) {
            this.refineByShow = !this.refineByShow;
            this.initMaxMin();
            this.config.events$.next({
                type: ResearchLayoutEvents.COLLAPSE_CHANGE,
                payload: !this.refineByShow
            });
        }
        this._cancelClick = false;
    }

    changeView(viewIndex: number) {
        if (this.view !== viewIndex) {
            // init all widths when changing view
            this.view = viewIndex;
            // when change view, init the layout width , max and min value.
            this.initLayout();
            this.isdraged = false;

            this.config.events$.next({
                type: ResearchLayoutEvents.LAYOUTMODE_CHANGE,
                payload: this.view
            });
        }
    }

    collapsedChange(e) {
        switch (this.view) {
            case 1:
                if (this.isdraged) {
                    if (e.collapsed) {
                        this.snippetView.previewWidth = e.collapsedComponentSize + e.sizes[e.sizes.length - 1];
                    } else {
                        this.snippetView.previewWidth = e.sizes[e.sizes.length - 1] - e.collapsedComponentSize;
                    }
                } else {
                    this.initWidth();
                }

                break;
            case 2:
                if (e.collapsed) {
                    this.toplistView.previewWidth = e.collapsedComponentSize + e.sizes[e.sizes.length - 1];
                } else {
                    this.toplistView.previewWidth = e.sizes[e.sizes.length - 1] - e.collapsedComponentSize;
                }

                break;
            case 3:
                if (this.isdraged) {
                    if (e.collapsed) {
                        this.sidelistView.previewWidth = e.collapsedComponentSize + e.sizes[e.sizes.length - 1] + 0.01;
                    } else {
                        this.sidelistView.previewWidth = e.sizes[e.sizes.length - 1] - e.collapsedComponentSize - 0.01;
                    }
                } else {
                    this.initWidth();
                }
                break;
            default:
                break;
        }
    }

    /* below is the function for layout */
    initCollapse(width: number) {
        if (width >= 1024) {
            this.refineByShow = true && !this.disableCollapse;
        } else {
            this.refineByShow = false;
        }
    }

    initLayout() {
        this.snippetView = Object.assign({}, snippetView);
        this.sidelistView = Object.assign({}, sidelistView);
        this.toplistView = Object.assign({}, toplistView);
        this.initWidth();
        this.initMaxMin();
    }

    initWidth() {
        if (this.refineByShow) {
            this.snippetView.previewWidth = snippetView.previewWidth;
            this.sidelistView.previewWidth = sidelistView.previewWidth;
            this.snippetView.middleWidth = snippetView.middleWidth;
            this.sidelistView.middleWidth = sidelistView.middleWidth;
            this.toplistView.previewWidth = toplistView.previewWidth;
        } else {
            this.snippetView.previewWidth = snippetView.collapsedpreviewWidth;
            this.snippetView.middleWidth = snippetView.collapsedMiddleWidth;
            this.sidelistView.previewWidth = sidelistView.collapsedpreviewWidth;
            this.sidelistView.middleWidth = sidelistView.collapsedMiddleWidth;
            this.toplistView.previewWidth = toplistView.collapsedpreviewWidth;
        }
    }

    initMaxMin() {
        // if expand, set the max and min without collapse
        // if collapsed, set the max and min with collapse
        if (this.refineByShow) {
            this.snippetView.previewMax = snippetView.previewMax;
            this.snippetView.previewMin = snippetView.previewMin;
            this.sidelistView.previewMax = sidelistView.previewMax;
            this.sidelistView.previewMin = sidelistView.previewMin;
        } else {
            this.snippetView.previewMax = snippetView.collapsedpreviewMax;
            this.snippetView.previewMin = snippetView.collapsedpreviewMin;
            this.sidelistView.previewMax = sidelistView.collapsedpreviewMax;
            this.sidelistView.previewMin = sidelistView.collapsedpreviewMin;
        }
    }

    sizeChange(e) {
        this.isdraged = true;
    }

    private _actionHandler(action) {
        if (action.type === ResearchLayoutActions.SET_COLLAPSE) {
            this.refineByShow = !action.payload;
        } else if (action.type === ResearchLayoutActions.SET_LAYOUT) {
            this.changeView(action.payload);
        }
    }
    /* above is the function for layout */

    // button start move
    public onPanStart(): void {
    }

    // button move end
    public onPanEnd(): void {
        this._renderer2.setStyle(this._el.querySelector('.collapse'), 'top', this.top);
        // need to set left to auto, otherwise the left value(moving) will affect
        this._renderer2.setStyle(this._el.querySelector('.collapse'), 'left', 'auto');
        this._renderer2.setStyle(this._el.querySelector('.collapse'), 'right', '-1px');
        this._renderer2.setStyle(this._el.querySelector('.expand'), 'top', this.top);
        this._renderer2.setStyle(this._el.querySelector('.expand'), 'left', 0);
    }

    // collapse button is moving
    public onBottonMove(event: any): void {
        const y = event.center.y;
        const x = event.center.x;
        // need to minus the panel top margin, because the icon will locate according to the panel parent, not the window
        this._top = y - this._panelTopMargin;
        this.top = this._top + 'px';
        this._left = x - this._collapseButton / 2 - this._navigationWidth;
        this.left = this._left + 'px';
        this._renderer2.setStyle(this._el.querySelector('.collapse'), 'top', this.top);
        this._renderer2.setStyle(this._el.querySelector('.collapse'), 'left', this.left);
        // if we want to move button, the button will not do the click operation
        this._cancelClick = true;
    }

    // expand button is moving
    public onBottonMoveForExpand(event: any): void {
        const y = event.center.y;
        const x = event.center.x;
        // need to minus the panel top margin, because the icon will locate according to the panel parent, not the window
        this._top = y - this._panelTopMargin;
        this.top = this._top + 'px';
        this._left = x - this._expandButton / 2 - this._navigationWidth;
        this.left = this._left + 'px';
        this._renderer2.setStyle(this._el.querySelector('.expand'), 'top', this.top);
        this._renderer2.setStyle(this._el.querySelector('.expand'), 'left', this.left);
        this._cancelClick = true;
    }
}
